import * as yup from "yup";
const validations = yup.object().shape({
  name: yup.string().required("validationMessages.required"),
  parent_id: yup.string().required("validationMessages.required"),
});

export default validations;
